import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/AuthContext";

import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import UtilMethods from "../../util/UtilMethods";
import {
  updateApprovalDetails,
  fetchSabbathDetails,
  deleteSabbathDetails,
} from "../../services/AdminServices";
import MarianLogo from "../common/MarianLogo.jsx"; // Import the MarianLogo component
import {
  getRetreatDetails,
  getMandatoryFields,
} from "../../util/RetreatFieldsConfig"; // Adjust path as needed
import {
  isZoomTokenValid,
  getZoomAccessToken,
  assignMeetingId,
  fetchZoomParticipants,
  fetchZoomAttendance,
} from "../../services/ZoomService"; // Named import
import { Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  FaEdit,
  FaTrash,
  FaSave,
  FaTimes,
  FaCheckCircle,
} from "react-icons/fa"; // Import the desired icons
import { send } from "emailjs-com";
import { sendEmail } from "../../services/EmailSender";
import { TextWrap } from "react-bootstrap-icons";

const ListSabbathRegistrationPage = () => {
  const [records, setRecords] = useState([]);
  const [currentRecords, setCurrentRecords] = useState([]);
  const { user, accessToken, setZoomToken, expiryTime, refreshToken, logout } =
    useAuth();
  const [filters, setFilters] = useState({
    name: "",
    phone: "",
    email: "",
    id: "",
    status: "",
    category: "Adult",
    meetingId: "",
    meetingDate: "",
  });
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    id: null,
    action: null,
  });
  const navigate = useNavigate();
  const recordsPerPage = 15;
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const fetchRecords = async () => {
    try {
      const data = await fetchSabbathDetails(filters);
      if (!data || data.length === 0) {
        setRecords([]);
        setCurrentRecords([]);
        setTotalPages(1);
        return;
      }

      const indexOfLastRecord = page * recordsPerPage;
      const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
      const currentRecords = data.slice(indexOfFirstRecord, indexOfLastRecord);

      const totalPages = Math.ceil(data.length / recordsPerPage);
      setTotalPages(totalPages);
      setPage(1);
      setRecords(data);
      setCurrentRecords(currentRecords);
    } catch (error) {
      console.error("Error fetching records:", error);
      setRecords([]);
      setCurrentRecords([]);
      setTotalPages(1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  useEffect(() => {
    const indexOfLastRecord = page * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = records.slice(indexOfFirstRecord, indexOfLastRecord);
    setCurrentRecords(currentRecords);
  }, [page, records]);

  const handleFilter = () => {
    fetchRecords();
  };

  const redirectToZoom = () => {
    const clientId = process.env.REACT_APP_ZOOM_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_ZOOM_REDIRECT_URI; // Append /callback to the redirect URI
    const zoomBaseUrl = "https://zoom.us/oauth/authorize"; // Define as constant
    if (!accessToken) {
      if (!clientId || !redirectUri) {
        console.error(
          "ZOOM_CLIENT_ID or ZOOM_REDIRECT_URI is not defined in environment variables."
        );
        alert("Zoom integration is not configured. Please contact support.");
        return;
      }

      // Construct the Zoom OAuth URL
      const zoomAuthUrl = `${zoomBaseUrl}?response_type=code&client_id=${encodeURIComponent(
        clientId
      )}&redirect_uri=${encodeURIComponent(redirectUri)}`;

      console.log("Redirecting to Zoom Authorization URL:", zoomAuthUrl);
      //window.alert(zoomAuthUrl);
      window.location.href = zoomAuthUrl; // Redirect the user to Zoom for authorization
    } else {
      console.log("Zoom Token available:", accessToken);
      //window.alert("Zoom Token available:", accessToken);
    }
    fetchRecords();
  };

  const handleExport = () => {
    const worksheet = XLSX.utils.json_to_sheet(records, {
      header: ["id", "firstName", "lastName", "email", "phone", "status"],
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "SabbathRecords");
    XLSX.writeFile(workbook, "SabbathRecords.xlsx");
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleDelete = (id) => {
    setConfirmModal({ show: true, id, action: "delete" });
  };

  const handleApprove = (id) => {
    setConfirmModal({ show: true, id, action: "approve" });
  };

  const handleEdit = (record) => {
    navigate("/sabbath", { state: { record } });
  };

  const confirmAction = async () => {
    const { id, action } = confirmModal;
    try {
      console.log(" action", action);
      console.log(" id", id);
      console.log(" user", user);
      console.log(" user.userID", user.userID);
      const approvedBy = user.userID;
      console.log(" expires_in", expiryTime);
      console.log(" refresh_token", refreshToken);
      const record = records.find((record) => record.id === id);
      console.log("Before Server call . record: ", record);
      console.log("Before Server call . accessToken: ", accessToken);
      console.log("Before Server call . approvedBy: ", approvedBy);
      if (!record) throw new Error("Record not found");
      const meetingId = await assignMeetingId(
        record.category,
        record.sabbathGroup
      );
      if (!meetingId) {
        console.error("Zoom Meeting not found");
        alert("Zoom Meeting not found. Please try again.");
        return;
      }
      if (action === "delete") {
        //await axios.delete(`${process.env.REACT_APP_API_URL}/sabbath/${id}`);
        console.log(" confirmAction delete");
        console.log(" confirmAction meetingId", meetingId);
        await deleteSabbathDetails(approvedBy, accessToken, meetingId, record);
        console.log("After Server call . delete: ", id);
        setConfirmModal({ show: false, id: null, action: null });
        fetchRecords();
      } else if (action === "approve") {
        // Step 2: Fetch record details for Zoom API
        await handleApproveAction(id);
        setConfirmModal({ show: false, id: null, action: null });
        fetchRecords();

      }
    } catch (error) {
      console.error("Error in confirmAction:", error.message);
      window.alert(
        "Error :" +
          error.message +
          " Please contact support or try again later."
      );
      //setErrorModal({ show: true, message: error.message });
    } finally {
      setConfirmModal({ show: false, id: null, action: null });
    }
  };
  // Handles the Approve button click, shows confirmation modal
  const handleApproveAction = async (id) => {
    // Retrieve the record, meetingId, and approvedBy here
    const record = records.find((rec) => rec.id === id);
    if (!record) {
      alert("Record not found.");
      return;
    }
    const meetingId = await assignMeetingId(record.category, record.sabbathGroup);
    const approvedBy = user?.userID;

    if (!accessToken) {
      redirectToZoom();
      return;
    } else if (!isZoomTokenValid(expiryTime) && refreshToken) {
      const tokenData = await getZoomAccessToken(
        null,
        refreshToken,
        setZoomToken
      );
      console.log("Token data:", tokenData);

      if (tokenData && tokenData.access_token && tokenData.expires_in) {
        console.log("Setting Zoom token with expiry...");

        // If the response includes a refresh token, pass it as well
        const { access_token, refresh_token, expires_in } = tokenData;

        // Pass the token, refresh token, and expiry to the context
        setZoomToken(access_token, refresh_token, expires_in);
      } else {
        console.error("Failed to obtain Zoom token.");
        alert("Failed to authorize with Zoom.");
        redirectToZoom();
        return;
      }
    }

    const response = await updateApprovalDetails(
      approvedBy,
      accessToken,
      meetingId,
      record
    );
    console.log("After Server call . response: ", response);
    console.log("After Server call . response: ", response.zoomID);
    console.log("After Server call . response: ", response.joinUrl);
    if (response && response.joinUrl) {
      const retreatDetails = getRetreatDetails(record.category);
      console.log("Retreat Details:", retreatDetails);
      const emailData = {
        to_name: `${record.firstName + " "} ${record.lastName}`,
        to_email: record.email || "",
        from_email: retreatDetails?.details?.email || process.env.REACT_APP_EMAILJS_DEFAULT_EMAIL_ID,
        zoomLink: response.joinUrl || "",
        category: record.category || "",
        id: `${record.type ? record.type + " " : ""}${record.id || ""}`,
        name: retreatDetails?.details?.name || record.category || "",
        date: retreatDetails?.details?.date || "",
        time: retreatDetails?.details?.time || "",
        location: retreatDetails?.details?.location || "",
        description: UtilMethods.stripHtmlTags(retreatDetails?.details?.description || ""),
        notes: UtilMethods.stripHtmlTags(retreatDetails?.details?.notes || ""),
        WOG: UtilMethods.stripHtmlTags(retreatDetails?.details?.WOG || ""),

      };
      if (record.category === "Adult" || record.category === "Youth") {
        await sendEmail(emailData, "TMP_Sabbath_Approval", "service_sabbath");
      } else {
        if (retreatDetails && retreatDetails.details.emailJS) {
          console.log("Sending email using template:", retreatDetails.details.emailJS);
          await sendEmail(emailData, retreatDetails.details.emailJS, "service_sabbath");
        }
      }
    } else {
      console.error("Invalid response data:", response);
      alert("Failed to approve the record. Please try again.");
    }
  };

  const handleDownloadAttendance = async () => {
    const { meetingId, meetingDate } = filters;
    if (!meetingId) {
      alert("Please enter a Meeting ID to download attendance.");
      return;
    }

    try {
      setLoading(true);
      const participants = await fetchZoomAttendance(
        meetingId,
        meetingDate,
        accessToken
      );
      if (!Array.isArray(participants) || participants.length === 0) {
        alert("No participants found for the specified Meeting ID.");
        return;
      }

      const attendance = participants.map((participant) => ({
        name: participant.name,
        email: participant.email,
        join_time: participant.join_time,
        leave_time: participant.leave_time,
        duration: participant.duration,
      }));

      const worksheet = XLSX.utils.json_to_sheet(attendance, {
        header: ["name", "email", "join_time", "leave_time", "duration"],
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");
      XLSX.writeFile(workbook, `Attendance_${meetingId}.xlsx`);
    } catch (error) {
      console.error("Error fetching attendance:", error);
      alert("Failed to download attendance. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleDownloadParticipants = async () => {
    const { meetingId } = filters;
    if (!meetingId) {
      alert("Please enter a Meeting ID to download participants.");
      return;
    }

    try {
      setLoading(true);
      const participants = await fetchZoomParticipants(meetingId, accessToken);
      //console.log("Participants:", participants);
      if (!Array.isArray(participants) || participants.length === 0) {
        alert("No participants found for the specified Meeting ID.");
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(participants, {
        header: ["name", "email", "join_time", "leave_time", "duration"],
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Participants");
      XLSX.writeFile(workbook, `Participants_${meetingId}.xlsx`);
    } catch (error) {
      console.error("Error fetching participants:", error);
      alert("Failed to download participants. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {/* Header */}
      <div className="container-fluid p-0 d-flex justify-content-between align-items-center">
        <MarianLogo />
        <h5 className="text-center mb-0">Sabbath Participants</h5>
        {user ? (
          <a
            href="/logout"
            className="h6 nav-item nav-link"
            onClick={(e) => {
              e.preventDefault();
              console.log("Logout Menu clicked");
              logout();
            }}
          >
            Logout
          </a>
        ) : (
          <a href="/login" className="nav-item nav-link">
            Login
          </a>
        )}
      </div>
      <div className="container-fluid mt-4 mb-1">
        {/* Filter Section */}
        <div className="filter-panel d-flex flex-wrap align-items-center mb-1">
          <div className="row w-100">
            <div className="col-md-2 col-sm-3 mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search by ID"
                name="id"
                value={filters.id}
                onChange={handleChange}
                aria-label="Search by ID"
              />
            </div>
            <div className="col-md-2 col-sm-3 mb-2">
              <select
                className="form-control"
                name="status"
                value={filters.status}
                onChange={handleChange}
                aria-label="Filter by Status"
              >
                <option value="">All</option>
                <option value="Approved">Approved</option>
                <option value="New">New</option>
                <option value="Deleted">Deleted</option>
              </select>
            </div>
            <div className="col-md-2 col-sm-3 mb-2">
              <select
                className="form-control"
                name="category"
                value={filters.category}
                onChange={handleChange}
                aria-label="Filter by Category"
              >
                <option value="Adult">Adult</option>
                <option value="Youth">Youth</option>
                <option value="Online Retreat">Online Retreat</option>
                <option value="11NOV2025">11NOV2025</option>
                <option value="MarianSpiritualWarfare">Marian Spiritual Warfare</option>
              </select>
            </div>
            <div className="col-md-2 col-sm-3 mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Name"
                name="name"
                value={filters.name}
                onChange={handleChange}
                aria-label="Search by Name"
              />
            </div>
            <div className="col-md-2 col-sm-3 mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Email"
                name="email"
                value={filters.email}
                onChange={handleChange}
                aria-label="Search by Email"
              />
            </div>
            <div className="col-md-2 col-sm-3 mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Phone"
                name="phone"
                value={filters.phone}
                onChange={handleChange}
                aria-label="Search by Phone"
              />
            </div>
            <div className="col-md-2 col-sm-3 mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Meeting ID"
                name="meetingId"
                value={filters.meetingId}
                onChange={handleChange}
                aria-label="Search by Meeting ID"
              />
            </div>
            <div className="col-md-2 col-sm-3 mb-2">
              <input
                type="date"
                className="form-control"
                placeholder="Search by Date"
                name="meetingDate"
                value={filters.meetingDate}
                onChange={handleChange}
                aria-label="Search by Meeting Date"
              />
            </div>
          </div>
        </div>

        {/* Button Actions Section */}
        <div className="d-flex flex-wrap justify-content-start mb-1">
          <button
            onClick={redirectToZoom}
            className="btn btn-secondary btn-sm mb-2 me-2"
          >
            Authorize with Zoom
          </button>
          <button
            onClick={async () => {
              if (
                window.confirm(
                  "Are you sure you want to approve ALL records listed in Current Page? This will send Zoom invites to all."
                )
              ) {
                for (const record of currentRecords) {
                  if (record.status !== "Deleted") {
                    console.log("Approving record:", record.id);
                    await handleApproveAction(record.id);
                  }
                }
                fetchRecords();
              }
            }}
            className="btn btn-success btn-sm me-2 mb-2"
            disabled={records.length === 0 || loading}
          >
            <FaCheckCircle style={{ fontSize: "0.9rem", marginRight: "4px" }} />
            Approve All
          </button>
          <button
            onClick={handleDownloadParticipants}
            className="btn btn-info btn-sm me-2 mb-2"
          >
            <i className="fas fa-download"></i> Download Participants
          </button>
          <button
            onClick={handleDownloadAttendance}
            className="btn btn-warning btn-sm me-2 mb-2"
          >
            <i className="fas fa-download"></i> Download Attendance
          </button>
          <button
            onClick={handleExport}
            className="btn btn-success btn-sm me-2 mb-2"
          >
            <i className="fas fa-file-excel"></i> Excel
          </button>
          <button
            className="btn btn-primary btn-sm me-2 mb-2"
            onClick={handleFilter}
          >
            <i className="fas fa-list"></i> List
          </button>
        </div>

        {/* Records Table */}
        <div className="table-responsive mt-1">
          <table className="table table-bordered mt-1">
            <thead>
              <tr style={{ maxHeight: "20px" }}>
                <th scope="col">Actions</th>
                <th>ID</th>
                <th colSpan={2}>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Category</th>
                <th>User Type</th>
                <th>Zoom Invite</th>
                <th>Status</th>
                <th>Created On</th>
                <th>Sabbath Group</th>
                <th>Address</th>
                <th>State</th>
                <th>Country</th>
                <th>Approved By</th>
                <th>Approved On</th>
                <th>User ID</th>
              </tr>
            </thead>
            <tbody>
              {currentRecords.length > 0 ? (
                currentRecords.map((record) => (
                  <tr
                    key={record.id}
                    className="record-row"
                    style={{ maxHeight: 3 }}
                  >
                    <td className="d-flex gap-2">
                      {/* Action Buttons */}
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Edit: Modify this record</Tooltip>}
                      >
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => handleEdit(record)}
                        >
                          <FaEdit
                            style={{ fontSize: "0.8rem", marginRight: "0" }}
                          />
                        </button>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>Approve: Approve this record</Tooltip>
                        }
                      >
                        <button
                          className="btn btn-success btn-sm"
                          onClick={() => handleApprove(record.id)}
                        >
                          <FaCheckCircle
                            style={{ fontSize: "0.8rem", marginRight: "0" }}
                          />
                        </button>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>
                            Delete: This action cannot be undone
                          </Tooltip>
                        }
                      >
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(record.id)}
                        >
                          <FaTrash
                            style={{ fontSize: "0.8rem", marginRight: "0" }}
                          />
                        </button>
                      </OverlayTrigger>
                    </td>
                    <td>{record.id}</td>
                    <td colSpan={2} style={{ whiteSpace: "nowrap" }}>
                      <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={
                          <Tooltip id={`tooltip-${record.id}`}>
                            {record.firstName + " " + record.lastName}
                          </Tooltip>
                        }
                      >
                        <span>{record.firstName + " " + record.lastName}</span>
                      </OverlayTrigger>
                    </td>
                    <td>{record.email}</td>
                    <td>{record.phone}</td>

                    <td>{record.category}</td>
                    <td>{record.type}</td>
                    <td>{record.zoomInvite ? "Yes" : "No"}</td>
                    <td>
                      <span
                        className={`badge ${
                          record.status === "Approved"
                            ? "badge-success"
                            : record.status === "Deleted"
                            ? "badge-danger"
                            : "badge-warning"
                        }`}
                      >
                        {record.status}
                      </span>
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>
                            {UtilMethods.formatDateTime(record.createdAt)}
                          </Tooltip>
                        }
                      >
                        <span>
                          {UtilMethods.formatDateShort(record.createdAt)}
                        </span>
                      </OverlayTrigger>
                    </td>
                    <td>{record.sabbathGroup}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {" "}
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>
                            {record.address && record.address + ", "}
                            {record.city && record.city + ", "}
                            {record.zip}
                          </Tooltip>
                        }
                      >
                        <span>
                          {`${record.address ? record.address + ", " : ""}${
                            record.city ? record.city + ", " : ""
                          }${record.zip || ""}`}
                        </span>
                      </OverlayTrigger>
                    </td>
                    <td>{record.state}</td>
                    <td>{record.country}</td>
                    <td>{record.approvedBy}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>
                            {UtilMethods.formatDateTime(record.approvedOn)}
                          </Tooltip>
                        }
                      >
                        <span>
                          {UtilMethods.formatDateShort(record.approvedOn)}
                        </span>
                      </OverlayTrigger>
                    </td>
                    <td>{record.userID}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="17" className="text-center">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {/* Pagination Section */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            {/* Pagination  */}
            <nav className="d-flex justify-content-center mt-4">
              <ul className="pagination">
                {Array.from({ length: totalPages }, (_, index) => (
                  <li
                    key={index + 1}
                    className={`page-item ${
                      page === index + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link btn-sm"
                      onClick={() => handlePageChange(index + 1)}
                      aria-current={page === index + 1 ? "page" : undefined}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))}
              </ul>
              {records.length > 0 && (
                <span className="text-muted mt-2 ml-2">
                  Showing {(page - 1) * recordsPerPage + 1} to{" "}
                  {Math.min(page * recordsPerPage, records.length)} of{" "}
                  {records.length}
                </span>
              )}
            </nav>
          </div>
        </div>
      </div>
      {/* Confirm Modal */}
      <Modal
        show={confirmModal.show}
        onHide={() => setConfirmModal({ show: false, id: null, action: null })}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to {confirmModal.action} the record with ID{" "}
          {confirmModal.id}?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() =>
              setConfirmModal({ show: false, id: null, action: null })
            }
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={confirmAction}>
            Yes,{" "}
            {confirmModal.action
              ? confirmModal.action.charAt(0).toUpperCase() +
                confirmModal.action.slice(1)
              : "Continue"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ListSabbathRegistrationPage;
